import {apiBase} from './ApiBase'
import camelcaseKeys from "camelcase-keys";
import {CardExchange} from "@/entity/CardExchange";
import {User} from "@/entity/User";

export const uketori = async ({cardId, code}) => {
  const result = await apiBase.post(`/exchange/${cardId}/${code}`, {})
  return new CardExchange(camelcaseKeys(result.data.data, {deep: true}))
}

export const getUketoriCard = async ({ id }) => {
  const result = await apiBase.get(`/exchange/${id}`, {})
  return new CardExchange(camelcaseKeys(result.data.data, { deep: true }))
}

export const getUketoriTargetUser = async ({ id }) => {
  const result = await apiBase.get(`/exchange/${id}/user`, {})
  return new User(camelcaseKeys(result.data.data, { deep: true }))
}

export const getUketoriCards = async () => {
  const result = await apiBase.get(`/exchange/cards`, {})
  return camelcaseKeys(result.data.data, { deep: true }).map((c) => {
    return new CardExchange(c);
  })
}

export const updateUketoriCard = async ({ id, cardExchange }) => {
  const result = await apiBase.put(`/exchange/${id}`, cardExchange.export())
  return new CardExchange(camelcaseKeys(result.data.data, { deep: true }));
}

export const canMakeMoreExchange = async ({ id }) => {
  const result = await apiBase.get(`/card/${id}/canMakeMoreExchange`)
  return result.data.data
}

export const resignExchange = async ({ id }) => {
  await apiBase.delete(`/exchange/${id}`)
}
